//@flow
import firebase from 'firebase'

export const logOut = () => firebase.auth().signOut()



// WEBPACK FOOTER //
// ./src/actions/auth.js